import React,{useState,useEffect} from 'react'
import {
  BrowserRouter,
  Route,
  Routes
} from 'react-router-dom'
import axios from 'axios'

import 'semantic-ui-css/semantic.css'
import 'animate.css'
import './assets/css/unicons.css'
import './assets/css/style.css'

import { RouteURL } from './services/redirect'

/*---------------------------------------
 Root Pages
---------------------------------------*/
import RootComponent from './pages/root'


/*---------------------------------------
 Page not Found: 404
---------------------------------------*/
import ErrorPage from './pages/ErrorPage/error'

/*---------------------------------------
Backend URL
---------------------------------------*/
axios.defaults.baseURL = 'https://coffeeshophotel.ph/hotel-reservation/api'


function App() {

  return (
    <React.Fragment>
       <BrowserRouter>
         <Routes>
           <Route path={RouteURL('*')} element={<RootComponent/>} />
           <Route path={RouteURL('404')} element={<ErrorPage/>} />
         </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
